import {
  ISearchSlim360O365UserAiInteractions,
  ISlim360O365UserAiInteractions,
} from '../../../services/slim360/o365UserAiInteractions/o365UserAiInteractions.model';
import o365UserAiInteractionsService from '../../../services/slim360/o365UserAiInteractions/o365UserAiInteractions.service';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Asynchronous thunk action

export const searchSlim360O365UserAiInteractions = createAsyncThunk(
  'searchSlim360O365UserAiInteractions',
  async (searchParam?: ISearchSlim360O365UserAiInteractions) => {
    const response = await o365UserAiInteractionsService
      .searchSlim360O365UserAiInteractions(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getSlim360O365UserAiInteractionsById = createAsyncThunk(
  'getSlim360O365UserAiInteractionsById',
  async (id: number) => {
    const response = await o365UserAiInteractionsService
      .getSlim360O365UserAiInteractionsById(id)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const saveSlim360O365UserAiInteractions = createAsyncThunk(
  'saveSlim360O365UserAiInteractions',
  async (data: ISlim360O365UserAiInteractions) => {
    const response = await o365UserAiInteractionsService
      .saveSlim360O365UserAiInteractions(data)
      .then((res) => {
        return res.body;
      });
    return response;
  }
);

export const deleteSlim360O365UserAiInteractions = createAsyncThunk(
  'deleteSlim360O365UserAiInteractions',
  async (id: number) => {
    const response = await o365UserAiInteractionsService
      .deleteSlim360O365UserAiInteractions(id)
      .then((res) => {
        return res.body;
      });
    return response;
  }
);
